module.exports = __webpack_public_path__ + "static/image1-dcab06edbd5ab4ab5a963fa1f864599d.jpg";